<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <button
      type="button"
      id="decline_tender"
      class="btn btn--darkblue decline-btn"
      @click="init()"
    >{{ $t('action.declineInvitation') }}</button>

    <modal
      modalId="alert-decline-modal"
      ref="alertDeclineModal"
    >
      <div slot="content">
        <p class="modal-pure-text"> {{ $t('vendor.bid.decline.popupTitle') }} </p>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeAlertDeclineModal()"
          aria-label="Close reveal"
        >{{ $t('action.cancel') }}</button>
        <button
          type="submit"
          class="btn btn--orange"
          @click="openSpecifyReasonModal()"
        >{{ $t('action.yesContinue') }}</button>
      </div>
    </modal>

    <modal
      modalId="specify-reason-modal"
      ref="specifyReasonModal"
    >
      <div slot="content">
        <p class="modal-pure-text"> {{ $t('vendor.bid.decline.reasonTitle') }}</p>
        <textarea
          type="text"
          :class="{'error-highlight': highlightInvalid }"
          v-model="declineReason"
          class="autosize"
          v-autosize
          required
        />
        <span
          class="form-error is-visible appr-error-message"
          v-if="apprErrHint"
        >
          {{ apprErrHint }}
        </span>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeSpecifyReasonModal()"
          aria-label="Close reveal"
        >{{ $t('action.cancel') }}</button>
        <button
          type="submit"
          class="btn btn--orange"
          v-hkldreset
          @click="declineInvitation()"
        >{{ $t('action.ok') }}</button>
      </div>
    </modal>

    <modal
      modalId="confirm-message-modal"
      ref="confirmMessageModal"
    >
      <div slot="content">
        <p class="modal-pure-text">{{ $t('vendor.bid.decline.confirmMessage') }}</p>
      </div>
      <div slot="btns">
        <button
          type="submit"
          class="btn btn--orange"
          @click="navHome()"
        >{{ $t('hint.okay') }}</button>
      </div>
    </modal>

  </div>
</template>

<script>
import lodash from 'lodash'

import router from '@/router'
import { sendEmail } from '@/api/postman/request'
import { EmailTypes, ActionTypes } from '@/utils/consts'
import { vendorBidStatus } from '@/utils/locale'
import { mapActions, mapGetters } from 'vuex'
import notification from '@/utils/notification'
import { getBidById } from '@/api/bids/request'
import Modal from '@/controls/Modal'

export default {
  name: 'DeclineTender',
  data () {
    return {
      apprErrHint: '',
      approver: '',
      declineReason: '',
      highlightInvalid: false,
    }
  },
  components: {
    Modal,
  },
  props: {
    className: {
      type: String,
      default: 'btn btn--orange',
    },
    tenderBidId: {
      type: String,
      default: null,
    },
  },

  methods: {
    ...mapActions('tenders', ['submitBidStatus']),
    openSpecifyReasonModal () {
      this.closeAlertDeclineModal()
      this.specifyReasonModal.open()
    },
    closeSpecifyReasonModal () {
      this.specifyReasonModal.close()
      this.apprErrHint = ''
    },
    openAlertDeclineModal () {
      this.alertDeclineModal.open()
    },
    closeAlertDeclineModal () {
      this.alertDeclineModal.close()
    },
    openConfirmMessageModal () {
      this.closeSpecifyReasonModal()
      this.confirmMessageModal.open()
    },
    closeConfirmMessageModal () {
      this.confirmMessageModal.close()
    },
    async declineInvitation () {
      this.highlightInvalid = false
      this.apprErrHint = ''
      if (!this.declineReason || !this.declineReason.trim()) {
        this.apprErrHint = this.$i18n.t('hint.enterDeclineReason')
      } else {
        const regex = /\s+/gi
        const wordCount = this.declineReason.trim().replace(regex, ' ').split(' ').length
        if (wordCount > 140) {
          this.highlightInvalid = true
          this.apprErrHint = this.$i18n.t('hint.overlengthDeclineReason')
          return
        }
        const action = this.isAddendum > 1 ? ActionTypes.tenders.addendum.bid.decline : ActionTypes.tenders.bid.decline
        const declineVersion = lodash.get(this.currentTender, 'general.version')
        await this.submitBidStatus({
          bidId: this.tenderBidId,
          request: { status: vendorBidStatus.DECLINED, declineReason: this.declineReason, declineVersion },
          action,
        })
        try {
          await this.emailNotification()
          this.openConfirmMessageModal()
        } catch (err) {
          notification.handleResponseError(err)
        }
      }
    },
    async emailNotification () {
      const response = await getBidById(this.tenderBidId)
      if (response && response.bid && response.bid.respondedOn) {
        const metaData = {
          respondedOn: response.bid.respondedOn,
          isSubmission: false,
        }
        await sendEmail(EmailTypes.tenders.submitBid, metaData)
      }
    },

    navHome () {
      this.closeConfirmMessageModal()
      router.push({ name: 'vendorHome' })
    },

    async init () {
      if (!this.specifyReasonModal) {
        this.specifyReasonModal = this.$refs.specifyReasonModal
      }
      if (!this.alertDeclineModal) {
        this.alertDeclineModal = this.$refs.alertDeclineModal
      }
      if (!this.confirmMessageModal) {
        this.confirmMessageModal = this.$refs.confirmMessageModal
      }
      await this.openAlertDeclineModal()
    },
  },
  computed: {
    ...mapGetters('tenders', ['currentTender', 'isAddendum']),
  },
  beforeDestroy () {
    if (this.specifyReasonModal) {
      this.specifyReasonModal.destroy()
    }
    if (this.alertDeclineModal) {
      this.alertDeclineModal.destroy()
    }
    if (this.confirmMessageModal) {
      this.confirmMessageModal.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
[modalId="specify-reason-modal"] {
  textarea {
    width: 100%;
  }
  .form-error {
    margin-top: 5px;
  }

}

</style>
